// Centralized public document links
// Ensure corresponding files exist in the public/ directory

export const AGB_URL = 'https://www.nebenkostenprofi.de/agb';
export const PRIVACY_URL = 'https://www.nebenkostenprofi.de/datenschutz';


